import React from "react";
const Index = () => {
  return <>Dashboard</>;
};

export default Index;
